import React from "react";
import { Link } from "react-router-dom";
import "./Web1920154.css";

function Web1920154(props) {
  const { overlapGroup1, backToImage } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-154 screen">
        <div className="overlap-group1-5" style={{ backgroundImage: `url(${overlapGroup1})` }}>
          <div className="rectangle-2-10 border-1px-dove-gray"></div>
          <Link to="/web-1920-80/0">
            <div className="group-142-2">
              <div className="overlap-group-10">
                <div className="rectangle-33-5 border-3px-picton-blue"></div>
                <div className="back-to-image-2 lato-medium-white-13px">{backToImage}</div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Web1920154;
